import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getBundleDetails } from "../../services/bundle";
import { bundleDetailsMapper } from "../../helpers/dataMapper";
import { BUNDLE_DETAILS_CRUMBS } from "../../constants/crumbs";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";
import SkuBundleDetails from "../SkuBundleDetails/SkuBundleDetails";
import BundleSkus from "./BundleSkus/BundleSkus";
import classes from "./BundleDetails.module.css";

const BundleDetails = () => {
  const [bundleDetails, setBundleDetails] = useState(null);
  const [bundleSkus, setBundleSkus] = useState([]);
  const [isBundleDetailsLoading, setIsBundleDetailsLoading] = useState(true);
  const [bundleDetailsError, setBundleDetailsError] = useState("");
  const pathParams = useParams();
  const bundleId = Number(pathParams.bundleId);

  useEffect(() => {
    const fetchBundleDetails = async () => {
      try {
        setIsBundleDetailsLoading(true);
        setBundleDetailsError("");
        const response = await getBundleDetails(bundleId);
        const {
          data: { bundle },
        } = response;
        const { details, bundleSkus } = bundleDetailsMapper(bundle);
        setBundleDetails(details);
        setBundleSkus(bundleSkus);
      } catch (err) {
        setBundleDetailsError("حدث خطأ أثناء تحميل تفاصيل المجموعة !");
      } finally {
        setIsBundleDetailsLoading(false);
      }
    };

    if (bundleId) {
      fetchBundleDetails();
    } else {
      setIsBundleDetailsLoading(false);
      setBundleDetailsError("عفواً لا يوجد تفاصيل لعرضها !");
    }
  }, [bundleId]);

  return (
    <div className={classes["bundle-details-wrapper"]}>
      <PortalBreadcrumb paths={BUNDLE_DETAILS_CRUMBS} />
      {isBundleDetailsLoading ? (
        <Loading className={classes["bundle-details__loading"]} />
      ) : bundleDetailsError ? (
        <EmptyContent
          className={classes["bundle-details__empty"]}
          message="لا يوجد تفاصيل لعرضها !"
        />
      ) : (
        <>
          <SkuBundleDetails
            details={{
              ...bundleDetails,
              bundleSkus: bundleSkus.map((sku) => ({
                id: sku.id,
                quantity: sku.quantity,
              })),
            }}
            isDetailsForSku={false}
          />
          <BundleSkus skus={bundleSkus} />
        </>
      )}
    </div>
  );
};

export default BundleDetails;
